import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { type InstallableApp, isConfinementAllowedPath, pathBelongsToApp } from "~/pwa/installableApps";

const useConfinementGuard = (activeApp: InstallableApp | null): void => {
	const { pathname } = useLocation();
	const navigate = useNavigate();
	useEffect(() => {
		if (!activeApp) return;
		if (pathBelongsToApp(pathname, activeApp)) return;
		if (isConfinementAllowedPath(pathname)) return;
		navigate(activeApp.startUrl, { replace: true });
	}, [activeApp, navigate, pathname]);
};

export default useConfinementGuard;
